export default __webpack_public_path__ + "static/media/ac_mil.74bb1e66.bmp";